import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import DashboardOutlinedIcon from '@material-ui/icons/DashboardOutlined';
import List from "@material-ui/icons/List";
//import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WbIncandescentOutlinedIcon from '@material-ui/icons/WbIncandescentOutlined';
import EcoOutlinedIcon from '@material-ui/icons/EcoOutlined';
import PlayCircleFilledWhiteOutlinedIcon from '@material-ui/icons/PlayCircleFilledWhiteOutlined';
import EuroOutlinedIcon from '@material-ui/icons/EuroOutlined';
import GroupIcon from '@material-ui/icons/Group';
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import NavPills from "components/NavPills/NavPills.js";

import styles from "assets/jss/material-kit-react/views/componentsSections/pillsStyle.js";

const useStyles = makeStyles(styles);

export default function SectionProject(props) {
  const {t} = props;
  const projectTeam = t.hr?"Projektni tim":"Project team";
  const classes = useStyles();
  function _link(text, href, target="_blank", rel="noopener noreferrer") {
    return <a className={classes.text} href={href} target={target} rel={rel}>{text}</a>
  }
  return (
    <div className={classes.section}>
      <div className={classes.container}>
          <div className={classes.title}>
            <h2>{t.about}</h2>
          </div>
          <div  className={classes.text}>
            <h4>
              <br/><br/>
              {(t.hr?"Naziv projekta":"Project title")+": "+t.titleLong}
              <br/><br/>
              {t.hr?"MIS kod: KK.01.1.1.04.0116"
                   :"MIS code: KK.01.1.1.04.0116"}
              <br/><br/>
              {t.hr?"Znanstvene organizacije koje sudjeluju na projektu su:"
                   :"The scientific organizations participating in the project are:"}
              <br/>
              <ul>
                <li><h4>{(t.hr?"Prijavitelj":"Applicant")+": "+t.ferit}</h4></li>
                <li><h4>{"Partner: "+t.sfsb}</h4></li>
              </ul>
              <br/>
              {t.hr?"Trajanje projekta: 20.12.2019. - 20.12.2022.":"Project duration: 20 December 2019 - 20 December 2022"}
              <br/><br/>
              {t.hr?"Ukupna vrijednost projekta: 2.231.639,40 HRK":"Total project value: HRK 2.231.639,40"}
              <br/><br/>
              {t.hr?"Iznos EU sufinanciranja: 1.557.050,94 HRK":"Amount of EU co-financing: HRK 1,557,050.94"}
              <br/><br/>
              {(t.hr?"Izvor financiranja":"Financing source")+": "+t.euFund}
              <br/><br/>
            </h4>
          </div>
          <GridContainer>
            <GridItem xs={12} sm={12} md={8} lg={6}>
              <NavPills
                color="primary"
                tabs={[
                  {
                    tabButton: t.hr?"Strategija":"Strategy",
                    tabIcon: PlayCircleFilledWhiteOutlinedIcon,
                    tabContent: (
                      <span>
                        <br />
                        <p>{t.strategy}</p>
                      </span>
                    )
                  },
                  {
                    tabButton: t.hr?"Samoodrživost":"Sustainability",
                    tabIcon: EuroOutlinedIcon,
                    tabContent: (
                      <span>
                        <br />
                        <p>{t.sustainability}</p>
                      </span>
                    )
                  },
                  {
                    tabButton: t.hr?"Ciljevi":"Goals",
                    tabIcon: List,
                    tabContent: (
                      <span>
                        <p>{t.hr?"Ciljevi":"Goals"}</p>
                        <div>
                          <ul>
                            <li>{t.goal1}</li>
                            <li>{t.goal2}</li>
                            <li>{t.goal3}</li>
                          </ul>
                        </div>
                        <br/>
                        <p>{t.goal4}</p>
                      </span>
                    )
                  }
                ]}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={12} lg={6}>
              <NavPills
                color="info"
                horizontal={{
                  tabsGrid: { xs: 12, sm: 4, md: 4 },
                  contentGrid: { xs: 12, sm: 8, md: 8 }
                }}
                tabs={[
                  {
                    tabButton: t.hr?"Doprinos":"Contribution",
                    tabIcon: DashboardOutlinedIcon,
                    tabContent: (
                      <span>
                        <p>{t.contribution}</p>
                        <br />
                      </span>
                    )
                  },
                  {
                    tabButton: t.hr?"Inovacija":"Innovation",
                    tabIcon: WbIncandescentOutlinedIcon,
                    tabContent: (
                      <span>
                        <p>{t.innovation}</p>
                        <br />
                      </span>
                    )
                  },
                  {
                    tabButton: t.hr?"Efikasnost":"Efficiency",
                    tabIcon: EcoOutlinedIcon,
                    tabContent: (
                      <span>
                        <p>{t.efficiency}</p>
                        <br />
                      </span>
                    )
                  },
                  {
                    tabButton: projectTeam,
                    tabIcon: GroupIcon,
                    tabContent: (
                      <span>
                        <p><strong>{_link(projectTeam+" FERIT Osijek","https://www.ferit.unios.hr/")}</strong></p>
                        <p>{_link("Prof.dr.sc. Drago Žagar, "+t.projectManager,"https://www.ferit.unios.hr/fakultet/imenik-djelatnika/dzagar#drago-zagar")}</p>
                        <p>{_link("Prof.dr.sc. Željko Hocenski","https://www.ferit.unios.hr/fakultet/imenik-djelatnika/dzagar#zeljko-hocenski")}</p>
                        <p>{_link("Doc.dr.sc. Tomislav Matić","https://www.ferit.unios.hr/fakultet/imenik-djelatnika/dzagar#tomislav-matic-zria")}</p>
                        <p>{_link("Doc.dr.sc. Ivan Aleksi","https://www.ferit.unios.hr/fakultet/imenik-djelatnika/dzagar#ivan-aleksi")}</p>
                        <p>{_link("dr.sc. Ivan Vidović","https://www.ferit.unios.hr/fakultet/imenik-djelatnika/dzagar#ivan-vidovic")}</p>
                        <p>{_link("Josip Zidar, mag.ing.comp.","https://www.ferit.unios.hr/fakultet/imenik-djelatnika/dzagar#josip-zidar")}</p>
                        <p>{_link("izv.Prof.dr.sc. Tomislav Keser","https://www.ferit.unios.hr/fakultet/imenik-djelatnika/dzagar#tomislav-keser")}</p>
                        <p>{_link("Prof.dr.sc. Goran Martinović","https://www.ferit.unios.hr/fakultet/imenik-djelatnika/dzagar#goran-martinovic")}</p>
                        <br />
                        <br />
                        <p><strong>{_link(projectTeam+" SFSB","https://www.sfsb.unios.hr/")}</strong></p>
                        <p>{_link("Prof.dr.sc. Marinko Stojkov","https://sfsb.unisb.hr/zavod-za-energetiku/cv-mstojkov-eng/")}</p>
                        <p>{_link("dr.sc. Mario Holik","https://sfsb.unisb.hr/zavod-za-energetiku/mario-holik/")}</p>
                      </span>
                    )
                  }
                ]}
              />
            </GridItem>
          </GridContainer>
        </div>
      </div>
  );
}
